import { render } from "./UserCreationForm.vue?vue&type=template&id=594b3ca2"
import script from "./UserCreationForm.vue?vue&type=script&lang=js"
export * from "./UserCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__